
    import './styles.scoped.css';
    export default {
  "resize-active": "awsui_resize-active_x7peu_hjirl_9",
  "resize-active-with-focus": "awsui_resize-active-with-focus_x7peu_hjirl_9",
  "resizer-wrapper": "awsui_resizer-wrapper_x7peu_hjirl_14",
  "divider-interactive": "awsui_divider-interactive_x7peu_hjirl_22",
  "is-borderless": "awsui_is-borderless_x7peu_hjirl_22",
  "resizer-button-wrapper": "awsui_resizer-button-wrapper_x7peu_hjirl_26",
  "divider": "awsui_divider_x7peu_hjirl_22",
  "divider-grouped": "awsui_divider-grouped_x7peu_hjirl_49",
  "divider-position-top": "awsui_divider-position-top_x7peu_hjirl_53",
  "divider-position-bottom": "awsui_divider-position-bottom_x7peu_hjirl_59",
  "divider-position-full": "awsui_divider-position-full_x7peu_hjirl_65",
  "divider-active": "awsui_divider-active_x7peu_hjirl_75",
  "visual-refresh": "awsui_visual-refresh_x7peu_hjirl_79",
  "is-last": "awsui_is-last_x7peu_hjirl_79",
  "resizer": "awsui_resizer_x7peu_hjirl_14",
  "has-focus": "awsui_has-focus_x7peu_hjirl_128",
  "tracker": "awsui_tracker_x7peu_hjirl_150"
};
  